import { formatDate } from '@/modules/_helpers/formatDate'
class PlainModel {
  constructor(props) {
    this.props = props
  }

  formatDate(date) {
    return formatDate(date)
  }

  getVatDate() {
    return this.formatDate(this.props.deliveryDate || this.props.date)
  }

  toJSON() {
    return this.props
  }
}
export default PlainModel
